module.exports = __webpack_public_path__ + "static/media/SchoolHM.b0b2035c.csv";